module.exports = "<li class=\"bd-bottom-grey-1 p-bottom-0 flex-justifycontent--spacebetween\">\n  {{{str}}}\n</li>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/config_row.html
// module id = 128
// module chunks = 0